import { render, staticRenderFns } from "./genderView.vue?vue&type=template&id=73ef91ee&scoped=true"
import script from "./genderView.vue?vue&type=script&lang=js"
export * from "./genderView.vue?vue&type=script&lang=js"
import style0 from "./genderView.vue?vue&type=style&index=0&id=73ef91ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ef91ee",
  null
  
)

export default component.exports